<template>
  <span>
    <router-link v-if="object" :to="{name: 'object/view/info', params: { objectId: object.id }}">{{$address(object.fullAddress) || '-'}}</router-link>
    <template v-else><strong class="text-grey-darken-3">määramata</strong></template>
  </span>
</template>

<script>
export default {
  props: {
    object: {
      required: true
    }
  }
}
</script>
